export default {
  auth: {
    loginAdminApiV2: 'v2/admin/account/signin',
    loginSellerApiV2: 'v2/seller/account/signin',
  },
  orders: {
    getGlobalOrders: '/v2/admin/order',
    getOrdersDetail: '/v2/admin/order/details',
    getOrderDetailsV2: 'v2/admin/order/details/:orderId',
    getSellerOrderDetailsV2: 'v2/seller/order/details/:orderId',
    setAsDelivered: '/v2/admin/order/details/:orderId/delivered',
    setAsCanceled: '/v2/admin/order/details/:orderId/cancel',
    setAsAccepted: '/v2/admin/order/details/:orderId/accept',
    sendNotificationToSeller:
      'v2/admin/order/details/:orderId/send-seller-notification',
    setDeliverySettings: 'v2/admin/order/details/:orderId/set-delivery-date',
    getOrderDetailEvents: 'v2/admin/order/details/:orderId/events',
    getOrderDeliveryInfo: 'v2/admin/order/details/:orderId/delivery-info',
    setOrderDeliveryInfo: 'v2/admin/order/details/:orderId/delivery',
    updateRemission: 'v2/admin/order/details/:orderId/evidence',
    filters: 'v2/admin/order/details/filters',
  },
  cart: {
    createCart: 'v2/admin/cart/bulk-create',
    updateCart: 'v2/admin/cart/:cartId',
    confirmCart: 'v2/admin/cart/:cartId/confirm',
    getCart: 'v2/admin/cart/:cartId',
    deleteCart: 'v2/admin/cart/:cartId',
    duplicateCart: 'v2/admin/cart/:cartId/duplicate',
    getCarts: 'v2/admin/cart/',
    searchProducts: 'v2/product/search',
  },
  buyer: {
    getBuyers: 'v2/admin/buyers',
    details: 'v2/admin/buyers/:userId',
    toggleTrusted: 'v2/admin/buyers/:userId/trusted-user',
    contactData: 'v2/admin/buyers/:userId/contact',
    updateContactData: 'v2/admin/buyers/:userId/contact',
    fiscalData: 'v2/admin/buyers/:userId/fiscal',
    updateFiscalData: 'v2/admin/buyers/:userId/fiscal',
    getAddresses: 'v2/admin/buyers/:userId/address',
    addAddress: 'v2/admin/buyers/:userId/address',
    deleteAddress: 'v2/admin/buyers/:userId/address/:addressId',
    setFavoriteAddress:
      'v2/admin/buyers/:userId/address/:addressId/set-default',
    setKam: 'v2/admin/buyers/:buyerId/staff',
  },
  seller: {
    create: 'v2/admin/sellers/new-seller',
    passwordReset: 'v2/seller/account/password-reset',
    passwordSet: 'v2/seller/account/password-set/',
    getDetails: 'v2/admin/sellers/:sellerId',
    updateDetails: 'v2/admin/sellers/:sellerId',
    getSellerAddress: 'v2/admin/sellers/:sellerId/warehouse/address',
    updateSellerAddress: 'v2/admin/sellers/:sellerId/warehouse/address',
    getSellers: 'v2/admin/sellers',
    contactData: 'v2/admin/sellers/:sellerId/contact',
    updateContactData: 'v2/admin/sellers/:sellerId/contact',
    updateSellerStatus: 'v2/admin/sellers/:sellerId',
    fiscalData: 'v2/admin/sellers/:sellerId/fiscal',
    updateFiscalData: 'v2/admin/sellers/:sellerId/fiscal',
    updateDeliveryDetails: 'v2/admin/sellers/set-delivery-details/:sellerId',
    getSellerOrders: 'v2/seller/order/details',
    getSellerSettings: 'v2/admin/sellers/:sellerId/settings',
    updateSellerSettings:
      'v2/admin/sellers/set-multiple-delivery-schedulers/:sellerId',
    sellerDetailOrder: {
      setAsDelivered: '/v2/seller/order/details/:orderId/delivered',
      setAsAccepted: '/v2/seller/order/details/:orderId/accept',
    },
    getDeliveryDays: '/v2/admin/sellers/delivery-days',
    product: {
      list: 'v2/seller/product',
      enable: 'v2/seller/catalog/products/enable',
      disable: 'v2/seller/catalog/products/disable',
      delete: 'v2/seller/catalog/products',
      update: 'v2/seller/catalog/product',
    },
  },
  retailers: {
    searchBuyers: 'v2/admin/buyers',
  },
  staff: {
    kamList: 'v2/admin/staff/kam',
  },
  zipCode: {
    getAddress: '/account/addresses/zipcode',
  },
  productCatalogV2: {
    list: 'v2/admin/product',
    enable: 'v2/admin/catalog/products/enable',
    disable: 'v2/admin/catalog/products/disable',
    delete: 'v2/admin/catalog/products',
    update: 'v2/admin/catalog/product',
    updateImage: 'v2/admin/catalog/product/image',
  },
  productsCatalog: {
    uploadBulkProducts: 'v2/admin/catalog/bulk-import',
    updateBulkProducts: 'v2/admin/catalog/bulk-update',
  },
  catalog: {
    getCategories: 'v2/admin/category',
    getProductsBySeller: 'v2/admin/product/seller',
  },
  fiscal: {
    getFiscalRegimes: 'v2/admin/tax/regimes',
    getCfdiUses: 'v2/admin/tax/cfdi-uses',
  },
  disbursement: {
    getCurrentBalance: 'v2/admin/disbursement/get-balance',
    executeDisbursement: 'v2/admin/disbursement',
  },
};
